import { createContext, useContext, useEffect, useMemo, useState } from "react";
import ApiRequest from "./ApiRequest";
import { ApiEndpoints } from "./ApiEndpoints";

const endpoints = ApiEndpoints.rbac;

const PermissionContext = createContext({
  status: "loading",
  permissionSlugs: null,
  hasPermission: () => true,
});

export const usePermissions = () => useContext(PermissionContext);

export function PermissionProvider({ children }) {
  const [status, setStatus] = useState("loading");
  const [permissionSlugs, setPermissionSlugs] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const finish = (slugs) => {
      if (cancelled) return;
      setPermissionSlugs(slugs || null);
      setStatus("ready");
    };

    ApiRequest("GET", endpoints.myPermissions)
      .then((response) => {
        if (response?.is_super_admin) {
          finish(null);
        } else if (response && !response.error) {
          finish(new Set(response.permissions.map((p) => p.slug)));
        } else {
          finish(new Set());
        }
      })
      .catch(() => finish(new Set()));

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo(
    () => ({
      status,
      permissionSlugs,
      hasPermission: (slug) =>
        status !== "ready" ? true : permissionSlugs ? permissionSlugs.has(slug) : true,
    }),
    [status, permissionSlugs]
  );

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
